import { TariffType } from '@/api/models/parking/lib/parking.types'
import { AppButton } from '@/components/shared/button'
import { formatNumberLocale } from '@/utils/number'

type Props = {
  price: number
  type: TariffType
  onSubmit: () => void
  loading?: boolean
}

export const FooterWithPrice = ({ price, type, onSubmit, loading }: Props) => (
  <div className="flex items-center justify-between border-t border-grey-20 bg-white pb-24 pt-20 xxs:flex-col xxs:items-stretch xxs:gap-12">
    <div className="flex flex-col xxs:flex-row xxs:items-center xxs:justify-between">
      <strong className="text-18 xxs:text-16">Тариф</strong>
      <strong className="text-36 xxs:text-28">
        {formatNumberLocale(price) || 0} ₽/
        {type === TariffType.Daily ? 'день' : 'час'}
      </strong>
    </div>
    <AppButton size="large" type="button" onClick={onSubmit} loading={loading}>
      Рассчитать стоимость
    </AppButton>
  </div>
)
